export interface CurrentUser {
  first_name: string;
  last_name: string;
}

export enum PasswordStrengthScore {
  none = 0,
  weak = 1,
  fair = 2,
  good = 3,
  great = 4,
}
